import { uniqueIdTransfer } from '@/apiCalls/uniqueIDTransferHelper';

import { EEventType } from '../eventType';

export interface IProps {
    onClick: () => void;
    checked: boolean;
    id?: string;
    eventType?: EEventType;
    className?: string;
}

export const testId = 'checkbox';

export function CheckBox({
    onClick,
    checked,
    id,
    eventType = EEventType.CLICK,
    className,
}: IProps): JSX.Element {
    function handleClick(): void {
        onClick();
        uniqueIdTransfer({
            eventType: eventType,
            applicationData: {
                id: id,
            },
        });
    }
    return (
        <div className={`${className} _flex items-center`} data-testid={testId}>
            <input
                id={id}
                type='checkbox'
                value=''
                checked={checked}
                onChange={handleClick}
                className='select-none w-4 h-4'
            />
        </div>
    );
}
